import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgChartsModule } from "ng2-charts";
import { routes } from "src/app/app.router";
import { InsightEgrcComponent } from "./insight-egrc.component";
import { InsightEgrcAuthoringToolsComponent } from "./authoring-tools/insight-egrc-authoring-tools.component";
import { DashboardComponent } from "./authoring-tools/dashboard/dashboard.component";
import { SharedModule } from "src/app/shared/shared.module";
import { TechStackControlSearchComponent } from "./tech-stack-control/tech-stack-control-search/tech-stack-control-search.component";
import { DeleteDialogComponent } from "./shared/dialogs/delete-dialog/delete-dialog.component";
import { TechStackControlCreateOrUpdateComponent } from "./tech-stack-control/tech-stack-control-create-or-update/tech-stack-control-create-or-update.component";
import { SuccessDialogComponent } from "./shared/dialogs/success-dialog/success-dialog.component";
import { RiskRegisterSearchComponent } from "./risk-management/risk-register/risk-register-search/risk-register-search.component";
import { RiskRegisterCreateOrUpdateComponent } from "./risk-management/risk-register/risk-register-create-or-update/risk-register-create-or-update.component";
import { RiskRegisterAssetInfoDialogComponent } from "./risk-management/risk-register/shared/dialogs/risk-register-asset-info-dialog/risk-register-asset-info-dialog.component";
import { InsightEgrcTableComponent } from "./shared/table/insight-egrc-table.component";
import { AgGridAngular } from "ag-grid-angular";
import { insightEgrcRouter } from "./insight-egrc.router";

@NgModule({
  declarations: [
    InsightEgrcAuthoringToolsComponent,
    DashboardComponent,
    TechStackControlSearchComponent,
    DeleteDialogComponent,
    TechStackControlCreateOrUpdateComponent,
    SuccessDialogComponent,
    RiskRegisterSearchComponent,
    RiskRegisterCreateOrUpdateComponent,
    RiskRegisterAssetInfoDialogComponent,
    InsightEgrcTableComponent,
  ],
  imports: [
    routes,
    insightEgrcRouter,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    NgbModule,
    NgChartsModule,
    SharedModule,
    AgGridAngular,
  ],
})
export class InsightEgrcModule {}
